import React, { useState } from "react";
import { Container, Text } from "components/common";
import Overlay from "components/common/Overlay/Overlay";
import UpdatePage from "components/Pages/Settings/SettingsMobile/UpdatePage";
import SuccessPage from "components/Pages/Settings/SettingsMobile/SuccessPage";
import Pages from "components/common/Pages";

const SettingsItemMobile = ({ initiallyExpanded, ...props }) => {
  const [open, setOpen] = useState(initiallyExpanded);
  const close = () => setOpen(false);
  return (
    <>
      <button
        type="button"
        className="mb-px w-full"
        onClick={() => setOpen(true)}
      >
        <Container paddingVertical={24}>
          <div className="flex justify-between">
            <div className="self-center">
              <Text weight="font-bold">{props.title}</Text>
            </div>
            <div>
              <i className="fas fa-chevron-right text-gray-secondary self-center" />
            </div>
          </div>
        </Container>
      </button>
      <Overlay isOpen={open} close={close}>
        <div
          className="pt-6 pb-8 px-12 h-full"
          style={{ backgroundColor: "#F9F9F9" }}
        >
          <Pages>
            <UpdatePage {...props} close={close} />
            <SuccessPage {...props} close={close} />
          </Pages>
        </div>
      </Overlay>
    </>
  );
};

export default SettingsItemMobile;
